import React, {useState, useEffect} from 'react';
import { BrowserRouter, useParams } from 'react-router-dom';
import Api from "./Api";


import LoginServ from './Estrutura/Serv/LoginServ';
import HeaderServ from './Estrutura/Serv/HeaderServ';
import MenuServ from './Estrutura/Serv/MenuServ';
import FooterServ from './Estrutura/Serv/FooterServ';
import RoutesServ from './Estrutura/Serv/RoutesServ';
import HeaderAdm from './Estrutura/Admin/HeaderAdmin';
import LoginAdmin from './Estrutura/Admin/LoginAdmin';
import PreloadAdmin from './Estrutura/Admin/PreloadAdmin';
import RoutesAdmin from './Estrutura/Admin/RoutesAdmin';
import MenuAdm from './Estrutura/Admin/MenuAdmin';
import FooterAdm from './Estrutura/Admin/FooterAdmin';
import VerificarServ from './Pages/Serv/VerificarServ';
import EstruJson from './JSONS/EstruServJson'; 
import FanPage from './Estrutura/Admin/FanPage';

import './App.css';


function App() {

    const [InstCad, setInstCad] = useState("");
    const [EstadoCad, setEstadoCad] = useState("Maranhão");
    const [CidadeCad, setCidadeCad] = useState("Bacabal");
    const [NomeCad, setNomeCad] = useState("");
    const [TelCad, setTelCad] = useState("");
    const [EmailCad, setEmailCad] = useState("");
    const [ContaCad, setContaCad] = useState("Lider");
    const [SenhaCad, setSenhaCad] = useState("");
    const [SenhaComfCad, setSenhaComfCad] = useState("");
    const [NomeGuerra, setNomeGuerra] = useState("");
    const [Patente, setPatente] = useState("")
    const [Loading, setLoading] = useState(false);
    const [Alert, setAlert] = useState(" ");
    const [AlertTipo, setAlertTipo] = useState(" ");
    const [Avisando, setAvisando] = useState([]);
    const [DadEmp, setDadEmp] = useState({});
    const [Carreg, setCarreg] = useState(false);
    const [Visitante, setVisitante] = useState(false);
    const [CidEst, setCidEst] = useState([]);

    const [User, setUser] = useState("L23252679");
    const [Conta, setConta] = useState("serv");
    const [IdConta, setIdConta] = useState(null);
    const [DadCont, setDadCont] = useState(null);
    const [Dados, setDados] = useState(null);
    const [IdUse, setIdUse] = useState(null);
    const [InfIdUse, setInfIdUse] = useState(null);
    const [InfIdConta, setInfIdConta] = useState(null);

    useEffect(() => {
      if(InfIdUse && InfIdConta && IdUse && Dados && IdConta && DadCont){
      setUser("S23458765")
      setConta("Admin")
      }
           
        }, [InfIdUse, InfIdConta, IdUse, Dados, DadCont, IdConta])

    // const [User, setUser] = useState("S23458765");
    // const [Conta, setConta] = useState("Admin");
    // const [IdConta, setIdConta] = useState("Geral");
    // const [DadCont, setDadCont] = useState("Emp");
    // const [Dados, setDados] = useState(EstruJson.Estrut.grupo.menu);
    // const [IdUse, setIdUse] = useState("giflQ9dcQNyZIaHRAhyc");
    // const [InfIdUse, setInfIdUse] = useState({});
    // const [InfIdConta, setInfIdConta] = useState({});

    // useEffect(() => {
    //   if(IdUse && IdConta){
    //     PegandoValor() 
    //    }    
    //   }, [IdUse, IdConta])

             

            

           
             useEffect(async () => {
                EntrandoLinks();                        
              }, []);

           useEffect(() => { 
              
                MsgAvisando();
             }, [Dados])
            

            
 
               useEffect(() => {
                DadoEmpresa();     
               }, [])

            

              // useEffect(() => {
              //   setInterval(() =>{verStatus()}, 
              //   60000);
              // }, [])
             
              // useEffect(() => {
              //   setInterval(() =>{}, 
              //   10000);
              // }, [])


               useEffect( async() => {
            
              //  const IdDGraud = await localStorage.getItem('Id'); 
              //  console.log(IdDGraud)
              // if(IdUse && IdDGraud){
              //  logarADM()
              // }
  
             }, [IdUse])

              const VerSeTemID = async ()=>{

                // const IdDGraud = await localStorage.getItem('Id');

                // if(IdDGraud){
                //  setIdUse(IdDGraud)
                //  } else {
                // setUser("L23252679")
                // setConta("Admin")
                //  }
              
                   
                 }
               const PegandoValor  = ()=>{
                
                     Api.TADadosIdContaIdUser(IdConta, IdUse, setInfIdConta, setInfIdUse);
    
                }


              const VerSeTaLogado = () => {
               console.log("Entrou Verlog")
               if(localStorage.getItem('Empresa') ){
                if(localStorage.getItem('Url')){
                  console.log("entrado aqui")
                  console.log(DadEmp)
                  logarADM()
                }
               }
              }
            
              const EntrandoLinks = () => {
                const Site = window.location.href;
              const VerSite =  Site.split("/");
             // console.log(VerSite)
              if(VerSite[3] === "Adm"){
              setUser("L23252679");
              setConta("Admin");
               
              } else {
                 VerSeTemID()
                }     
               
              }
                

              const DadoEmpresa = async ()=>{
                if (navigator.onLine) {
                 setCarreg(true);
                  await Api.DadasEmpresasIni(Dados, setDadEmp,  setCarreg, setVisitante);
                  
                } else {
                  setAlert("Sem Internet");
                  setAlertTipo("danger");
                }
    
                   
              }
              
                    const bloqueio = () => {
                      
                      // if(Conta === "serv" && User !== "V23736478" && User !== "L23252679") {
                      //   if(Dados.conta.serv.desbloqueado === false){
                      //     localStorage.setItem('roma', "B23987845");
                      //     setUser("B23987845");
                          
                      //   }
                      // }
                    }

                    const MsgAvisando = ()=>{
                      Api.AvisandoMsg(Dados, setAvisando)
                    }


                  const cadastroServ =  async ()=> {
                    await setLoading(true);
                    if(EmailCad !== "" && SenhaCad !== "" && NomeCad !== "" && TelCad !== ""
                    && SenhaComfCad !== "" && CidadeCad !== "" && EstadoCad !== ""
                    && InstCad !== "" && ContaCad !== "" && Patente !== "" && NomeGuerra !== "") {
                            if(SenhaComfCad === SenhaCad) {
                              if(InstCad !== "Instituição" ) {
                                if(CidadeCad !== "Cidade") {
                                  if(EstadoCad !== "Estado") {
                                    if(ContaCad !== "Conta") {
                                      await setConta("serv");
                                      const res = await Api.cadastroserv(EmailCad, SenhaCad, NomeCad,
                                         TelCad, CidadeCad, EstadoCad, InstCad,  ContaCad, NomeGuerra, Patente);
                                      if(res === "ok") {
                                        await localStorage.setItem('brasil', "serv");
                                        await localStorage.setItem('roma', "V23736478");
                                        await verStatus();
                                      } else {
                                        setAlert(res);
                                      }


                                      } else {
                                        setAlert("Escolha Uma Conta"); 
                                      }
                                    } else {
                                      setCidadeCad(" ");
                                      setAlert("Escolha Um Estado");
                                    }
                                  } else {
                                    setAlert("Escolha Uma Cidade");
                                  }
                                } else {
                                  setAlert("Escolha Uma Instituição");
                              }

                            } else {
                              setAlert("A Confirmação de senha está errado!");
                            }
                      } else {
                          setAlert("Preencha Todos os Campos!");
                      }

                      await setLoading(false);

                  }


                  const logarServ =  async ()=> {
                    await setLoading(true);
                    if(EmailCad !== "" && SenhaCad !== ""){
                      const res = await Api.LogandocontaServ(EmailCad, NomeCad, IdUse,  SenhaCad, setLoading, setDados);
                      if(res === "ok") {                      
                        await verStatus();
                      } else {  
                        await setAlert(res);
                      }
                    } else {
                       
                      setAlert("Preencha Todos os Campos");
                    }
                    await setLoading(false);
                  }

                  const logarADM =  async ()=> {
                  
                    await setLoading(true);
                    const res = await Api.LogandocontaADM(IdUse, setIdConta, setDadCont, setInfIdConta, setInfIdUse, setLoading, setDados,  setUser, setConta);
                    
                   
                    await setLoading(false);
                  }

                  
                  

                  const AtivandoServ = async ()=> {
                    const res = await Api.AtivarcontaServ();
                    if(res === "Atualizado com sucesso!"){
                      setAlert("Ativado com sucesso!");
                      setAlertTipo("success");
                    } else {
                      setAlert("Seu perfil não foi ativado!");
                      setAlertTipo("danger")
                      verStatus();
                    }
                  }

                    //aqui vai servir para colocar qual acesso no site
                  const verStatus = async() => {
                   
                  
                    const status = await localStorage.getItem('roma');
                    const fromat = await localStorage.getItem('brasil');
                    
                    if( status !== null ){
                      setUser(status);
                      setConta(fromat);
                    } else {
                      setUser("L23252679");
                      setConta("serv");
                    }

                    
                    
                   } 
                   
                   const sair = async ()=> {
                    setUser("L23252679")
                    setConta("Admin")
                    setIdConta(null);
                    setDadCont(null);
                    setDados(null);
                    setIdUse(null);
                    setInfIdUse(null);
                    setInfIdConta(null);
                    await localStorage.setItem('Id', "");
                  }
                    // aqui vai servir para trazer os dados dele na hora da atualização 
                  const ObtendoDados = async () => {
                      setLoading(true);
                      const res = await Api.AnliseDados(Dados, setDados, setLoading);
                  }

            


                  const CriarDados = async () => {
                    await Api.gerarDados();
                  }

                  const ApagarDados = async () => {
                    await Api.excluirDados();
                  }

                  const VerBo = async () => {
                    await localStorage.setItem('roma', "BO123");
                    await localStorage.setItem('brasil', "BO");
                    setUser("BO123");
                    setConta("BO");
                  }
               const PAinelAdm = async () => {
                    setUser("L23252679");
                   setConta("Admin");
                  }
               



  return (
    <div class="wrapper">
              {User === "L23252679" &&  Conta === "serv" &&
              <FanPage
              PAinelAdm={PAinelAdm}
              Visitante={Visitante}
              DadEmp={DadEmp}
              setConta={setConta} 
              setEmail={setEmailCad} 
              Email={EmailCad} 
              Senha={SenhaCad} 
              setSenha={setSenhaCad} 
              Confirsenha={SenhaComfCad}
              setConfirsenha={setSenhaComfCad}
              Cidade={CidadeCad}
              setCidade={setCidadeCad}
              Estado={EstadoCad}
              setEstado={setEstadoCad}
              Instituicao={InstCad}
              setInstituicao={setInstCad}
              Nome={NomeCad}
              setNome={setNomeCad}
              Telefone={TelCad}
              setTelefone={setTelCad}
              cadastrando={cadastroServ}
              ContaTipo={ContaCad}
              setContaTipo={setContaCad}
              setLoading={setLoading}
              Loading={Loading}
              logando={logarServ}
              Alert={Alert}
              setAlert={setAlert}
              NomeGuerra={NomeGuerra}
              setNomeGuerra={setNomeGuerra}
              Patente={Patente}
              setPatente={setPatente}
              Bo={VerBo}
              setIdUser={setIdUse}
             
              />  
              }
               

             
               {User === "L23252679" &&  Conta === "Admin" &&
              <LoginAdmin
              DadEmp={DadEmp}
              setConta={setConta} 
              setEmail={setEmailCad} 
              Email={EmailCad} 
              Senha={SenhaCad} 
              setSenha={setSenhaCad} 
              Confirsenha={SenhaComfCad}
              setConfirsenha={setSenhaComfCad}
              Cidade={CidadeCad}
              setCidade={setCidadeCad}
              Estado={EstadoCad}
              setEstado={setEstadoCad}
              Instituicao={InstCad}
              setInstituicao={setInstCad}
              Nome={NomeCad}
              setNome={setNomeCad}
              Telefone={TelCad}
              setTelefone={setTelCad}
              cadastrando={cadastroServ}
              ContaTipo={ContaCad}
              setContaTipo={setContaCad}
              setLoading={setLoading}
              Loading={Loading}
              logando={logarADM}
              Alert={Alert}
              setAlert={setAlert}
              NomeGuerra={NomeGuerra}
              setNomeGuerra={setNomeGuerra}
              Patente={Patente}
              setPatente={setPatente}
              Bo={VerBo}
              setIdUser={setIdUse}
             
              />  
              }
            
         {User === "P23252679" &&  Conta === "Admin" &&
              <PreloadAdmin
              DadEmp={DadEmp}
              setConta={setConta} 
              setEmail={setEmailCad} 
              Email={EmailCad} 
              Senha={SenhaCad} 
              setSenha={setSenhaCad} 
              Confirsenha={SenhaComfCad}
              setConfirsenha={setSenhaComfCad}
              Cidade={CidadeCad}
              setCidade={setCidadeCad}
              Estado={EstadoCad}
              setEstado={setEstadoCad}
              Instituicao={InstCad}
              setInstituicao={setInstCad}
              Nome={NomeCad}
              setNome={setNomeCad}
              Telefone={TelCad}
              setTelefone={setTelCad}
              cadastrando={cadastroServ}
              ContaTipo={ContaCad}
              setContaTipo={setContaCad}
              setLoading={setLoading}
              Loading={Loading}
              logando={logarADM}
              Alert={Alert}
              setAlert={setAlert}
              NomeGuerra={NomeGuerra}
              setNomeGuerra={setNomeGuerra}
              Patente={Patente}
              setPatente={setPatente}
              Bo={VerBo}
              setIdUser={setIdUse}
             
              />  
              }
            
         

            {User === "S23458765" && Conta === "Admin" &&            
              <BrowserRouter>
              <HeaderAdm
              Dados={Dados}
              DadEmp={DadEmp}
              InfIdConta={InfIdConta}
              InfIdUse={InfIdUse}
              />
              <MenuAdm
               InfIdConta={InfIdConta}
              InfIdUse={InfIdUse}
              DadCont={DadCont}
              sair={sair}
              Dados={Dados}
              CriarDados={CriarDados}
              ApagarDados={ApagarDados}
              />
              <RoutesAdmin
              IdConta={IdConta}
              DadCont={DadCont}
              DadEmp={DadEmp}
              Loading={Loading}
              setLoading={setLoading}
              Alert={Alert}
              setAlert={setAlert}
              AlertTipo={AlertTipo}
              setAlertTipo={setAlertTipo}
              Dados={Dados}
              IdUse={IdUse}
              CidEst={CidEst}
              Avisando={Avisando}
              setAvisando={setAvisando}
              setDados={setDados}
              InfIdConta={InfIdConta}
              InfIdUse={InfIdUse}
              />
              <FooterAdm />
              </BrowserRouter>
              }
              

      </div>
    );
  }
  
  export default App;